import { render } from "./MyRoomBookings.vue?vue&type=template&id=3abde13b"
import script from "./MyRoomBookings.vue?vue&type=script&lang=js"
export * from "./MyRoomBookings.vue?vue&type=script&lang=js"

import "./MyRoomBookings.vue?vue&type=style&index=0&id=3abde13b&lang=less"
script.render = render

export default script